import moment from "moment";
import { InquiryAppointment } from "./types";
import { UpdateInquiryAppointmentRequestPayload } from "./use-inquiry-appointments";

export const formatAppointmentForUpdate = (appointment: InquiryAppointment): UpdateInquiryAppointmentRequestPayload => {
  const { typeId, reasonToCancelId, cancellationReasonOther, ...rest } = appointment;
  const trimmedReason = reasonToCancelId?.trim();
  const trimmedOther = cancellationReasonOther?.trim();
  return {
    ...rest,
    scheduledDateTime: moment.utc(appointment.scheduledDateTime).format("YYYY-MM-DDTHH:mm:ssZ"),
    ...(appointment.endDateTime && {
      endDateTime: moment.utc(appointment.endDateTime).format("YYYY-MM-DDTHH:mm:ssZ")
    }),
    staffMembers: appointment.staffMembers.map(({ id }) => id).filter(id => id),
    attendees: appointment.attendees.map(({ id }) => id),
    ...(trimmedReason ? { reasonToCancelId: trimmedReason } : {}),
    ...(trimmedOther ? { cancellationReasonOther: trimmedOther } : {})
  };
};
